import { render, staticRenderFns } from "./TrainingAIStructureModal.vue?vue&type=template&id=97460dbe&"
import script from "./TrainingAIStructureModal.vue?vue&type=script&lang=js&"
export * from "./TrainingAIStructureModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports